import { render, staticRenderFns } from "./processDetail.vue?vue&type=template&id=16d2b878"
import script from "./processDetail.vue?vue&type=script&lang=js"
export * from "./processDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16d2b878')) {
      api.createRecord('16d2b878', component.options)
    } else {
      api.reload('16d2b878', component.options)
    }
    module.hot.accept("./processDetail.vue?vue&type=template&id=16d2b878", function () {
      api.rerender('16d2b878', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/mdm/pim/processDetail.vue"
export default component.exports